import { api } from './client'
import type { ImportKind } from './imports'

/**
 * F-068 (TASK-0322, REQ-239-001): mappature di importazione salvate (`/api/import-mappings`). Ognuno
 * vede le proprie e quelle condivise; modifica ed elimina solo le proprie (l'Admin anche le altrui);
 * solo l'Admin può crearne o renderne una condivisa (403 agli altri). Nome unico per proprietario e tipo.
 */
export interface ImportMapping {
  id: number
  kind: ImportKind | 'products'
  name: string
  shared: boolean
  ownerUserId: number
  isOwner: boolean
  /** Testo dell'intestazione del file -> chiave del campo. */
  mapping: Record<string, string>
  createdAt: string
  updatedAt: string | null
}

export interface ImportMappingRequest {
  kind: ImportKind | 'products'
  name: string
  mapping: Record<string, string>
  shared: boolean
}

export const importMappingsApi = {
  list: (kind: ImportKind | 'products') =>
    api<{ items: ImportMapping[] }>(`/api/import-mappings?kind=${encodeURIComponent(kind)}`),
  create: (data: ImportMappingRequest) =>
    api<ImportMapping>('/api/import-mappings', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: number, data: ImportMappingRequest) =>
    api<ImportMapping>(`/api/import-mappings/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  remove: (id: number) => api<void>(`/api/import-mappings/${id}`, { method: 'DELETE' }),
}
